export function Logo({ className = "h-12", variant = "transparent" }) {
  const src = variant === "black" ? "/assets/logo_appicon_black.png" : "/assets/logo_transparent.png";
  return (
    <img
      src={src}
      alt="I-65 Ryders"
      className={`${className} w-auto select-none drop-shadow-[0_4px_18px_rgba(212,175,55,0.28)]`}
      draggable={false}
      data-testid="i65-logo"
    />
  );
}
